import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  set(key: string, payload: string) {
    sessionStorage.setItem(key, payload)
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }

  get(key: string) : any {
    return sessionStorage.getItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}
